import { render, staticRenderFns } from "./AppChipsContainer.vue?vue&type=template&id=0536a9b3&scoped=true&"
import script from "./AppChipsContainer.vue?vue&type=script&lang=js&"
export * from "./AppChipsContainer.vue?vue&type=script&lang=js&"
import style0 from "./AppChipsContainer.vue?vue&type=style&index=0&id=0536a9b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0536a9b3",
  null
  
)

export default component.exports